import PieChart from "@/components/Common/PieChart/PieChart.js";
import BarChart from "@/components/POI/BarChart/BarChart.js";
import DoughnutChart from "@/components/POI/DonutChart/DonutChart.js";
import "./POIManagedBoard.scss";
import Vue from "vue";
import VueNumber from "vue-number-animation";
import axios from "axios";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getTokenHeader } from "@/helpers/commonHelper";

Vue.use(VueNumber);

export default {
  name: "POIManagedBoard",
  props: ["pois"],

  components: { PieChart, BarChart, DoughnutChart },
  data() {
    return {
      dialog: false,
      poiCount: 0,
      openBarStatisticData: {},
      usedCategoryTypes: [],
      statisticDonutData: {},
      contactStatistic: {},
      statisticBarData: {},
      statisticData: {},
      descriptionData: {},
      barOptions: {
        legend: {
          display: false
        },
        responsive: true
      },
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      },
      chartStyle: { position: "relative" },
      headers: [
        {
          text: "POI Title",
          value: "title",
          sortable: false
        },
        {
          text: "Bearbeiten",
          value: "icon",
          sortable: false
        }
      ],
      poisWithoutDescription: [],
      page: 1,
      itemsPerPage: 10
    };
  },
  async mounted() {
    await this.getStatistics();
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    randomHex() {
      const randomColor = [];
      for (let i in this.usedCategoryTypes) {
        if (randomColor.length <= i) {
          randomColor.push(
            "#" +
              ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0")
          );
        }
      }
      return randomColor;
    }
  },
  methods: {
    async getStatistics() {
      const headers = getTokenHeader();
      const params = {
        principal: this.currentPrincipal
      };
      try {
        const {
          data: {
            countPOIs,
            countRoutes,
            pois,
            countActivePOIs,
            countNotActivePOIs,
            countWithoutDescription,
            countWithDescription,
            countWithPartialDescription,
            poisWithoutDescription,
            totalKilometers,
            avgKilometers,
            maxKilometers
          }
        } = await axios.get(`${env.poi_api_client_url}poi/statistics`, {
          params,
          headers
        });
        this.usedCategoryTypes = pois.map(poi => poi.categoryType);
        this.poiCount = countPOIs + countRoutes;
        this.statisticDonutData = {
          labels: ["Anteil POIs", "Anteil Strecken"],
          datasets: [
            {
              backgroundColor: this.randomHex,
              data: [countPOIs, countRoutes]
            }
          ]
        };
        this.$refs.doughnutChart?.render();
        this.statisticData = {
          labels: this.usedCategoryTypes,
          datasets: [
            {
              backgroundColor: this.randomHex,
              data: pois.map(poi => poi.count)
            }
          ]
        };
        this.$refs.pieChart?.render();
        this.openBarStatisticData = {
          labels: ["Veröffentlichte POIs", "Unveröffentlichte POIs"],
          datasets: [
            {
              backgroundColor: this.randomHex,
              data: [countActivePOIs, countNotActivePOIs]
            }
          ]
        };
        this.$refs.openBarChart?.render();
        this.descriptionData = {
          labels: [
            "Beschreibungen sind vollständig",
            "Beschreibungen fehlen komplett",
            "Kurz- oder Hauptbeschreibung fehlt"
          ],
          datasets: [
            {
              backgroundColor: this.randomHex,
              data: [
                countWithDescription,
                countWithoutDescription,
                countWithPartialDescription
              ]
            }
          ]
        };
        this.$refs.descriptionPieChart?.render();
        this.poisWithoutDescription = poisWithoutDescription;
        this.statisticBarData = {
          labels: [
            "Längste Strecke (in km)",
            "Gesamt Kilometer",
            "Durchschnittsstrecke (in km)"
          ],
          datasets: [
            {
              start: 0,
              maxBarThickness: 50,
              backgroundColor: this.randomHex,
              data: [maxKilometers, totalKilometers, avgKilometers]
            }
          ]
        };
        this.$refs.barChart?.render();
      } catch (err) {
        await this.$store.dispatch("createError", err);
      }
    }
  },
  watch: {
    async currentPrincipal() {
      await this.getStatistics();
    }
  }
};
